export default __webpack_public_path__ + "static/media/chevron-down-icon.24bdf167.svg";